import { Cart, CartShippingDiscount, CouponRedeem, Discount } from './cart'
import { CustomerAddress, Customer } from './customer'

export enum ShippingMethodCode {
  STANDARD = 'JAU_STD',
  EXPRESS = 'JAU_EXP',
  SAME_DAY = 'JAU_SMD',
  BULKY_JAU_NTD = 'JAU_NTD',
  STANDARD_JNZ = 'JNZ_STD',
  EXPRESS_JNZ = 'JNZ_EXP',
  SAME_DAY_JNZ = 'JNZ_SMD',
  BULKY_JNZ_NTD = 'JNZ_NTD',
  STANDARD_RTM = 'RTM_STD',
  EXPRESS_RTM = 'RTM_EXP',
  SAME_DAY_RTM = 'RTM_SMD',
  BULKY_RTM_NTD = 'RTM_NTD',
}

type ItemError = {
  itemCode: string
  error: string
}

type ErrorMessage = {
  message?: string
  itemErrors?: ItemError[]
}
export interface CheckoutDetails {
  deliveryType?: DeliveryType
  cartSummary: Cart
  customer?: Customer
  billingAddress?: CustomerAddress
  shippingAddress?: CustomerAddress
  shippingMethods?: ShippingMethod[]
  paymentSession?: string
  deliverynotes?: string
  isLoggedIn: boolean
  selectedShippingMethod?: string
  isCreditAvailable?: boolean
  shippingTier?: string
  paymentMethods?: PaymentMethod[]
  latitudePayUrl?: string
  discount?: Discount
  isDiscountCode?: boolean
  eligibleForInsurance?: boolean
  coupon?: CouponRedeem
  fullBasket?: boolean
  customerGroup?: string
  cartContainsGiftCard?: boolean
  cartShippingDiscount?: CartShippingDiscount
  errorMessages?: ErrorMessage[]
  customerType?: string
  isBulkyItem?: boolean
  customerKey?: string
}

export interface ReturnRequest {
  orderNumber: string
  products: {
    lineItemId: string
    quantity: number
    comment?: string
    shipmentState?: string
  }[]
  returnTrackingId?: string
  returnDate?: string
}

export interface UpdateContactDetailsRequest extends Record<string, string | undefined> {
  email: string
  firstName: string
  lastName: string
  company?: string
  addressLine1?: string
  addressLine2?: string
  suburb: string
  streetName?: string
  streetNumber?: string
  city: string
  state: string
  country: string
  latitude?: string
  longitude?: string
  placeId?: string
  postalCode: string
  phone: string
  address: string
  isManual: string
}

export interface ShippingMethod {
  code: ShippingMethodCode
  name: string
  price: number
  isAvailable: boolean
  condition?: string
  description?: string
  collectionStore?: number
  isBulkyItem?: boolean
  deliverySurcharge?: number
}

export enum DeliveryType {
  DELIVERY = 'deliveryStore',
  PICKUP = 'clickCollect',
  WAREHOUSE = 'deliveryWarehouse',
}

export interface UpdateDeliveryTypeRequest {
  deliveryType: DeliveryType
}

export interface CheckoutPaymentRequest {
  deliveryCode?: string
  storeKey?: string
  forterCookie?: string
  storesPurchaseOrderNumber?: string
}

export interface SavePaymentMethodRequest {
  encryptedCardNumber?: string
  encryptedExpiryMonth?: string
  encryptedExpiryYear?: string
  encryptedSecurityCode?: string
  isDefault?: boolean
}

export interface EditPaymentMethodRequest extends SavePaymentMethodRequest {
  refId?: string
}

export interface DeletePaymentMethod {
  refId: string
}

export interface PaymentMethod {
  id: string
  title: string
  type?: string
}

export interface ApplyCreditResponse {
  orderNumber: string
}

export interface LatitudeCreateOrderRequest {
  gatewayReference: string
  merchantReference: string
  transactionReference: string
}

export interface RedeemGiftCardRequest {
  giftCardId: string
  pinCode?: string
}

export enum CHECKOUT_CART_MESSAGE {
  CNC_NO_STOCK = 'CNC_NO_STOCK',
  CNC_INSUFFICIENT_STOCK = 'CNC_INSUFFICIENT_STOCK',
  DELIVERY_NO_STOCK = 'Sorry, item is out of stock. Please remove the item.',
  DELIVERY_INSUFFICIENT_STOCK = 'Sorry, the required quantity isnt available, please reduce the quantity.',
  DELIVERY_NO_FREE_FREIGHT = 'Sorry but your product does not qualify for free freight',
  MARKETPLACE_ITEM = 'Direct from Supplier to store - 15-Day Lead Time',
  BULKY_GOODS_FREIGHT = 'Bulky goods freight',
  OUT_OF_STOCK = 'Out of stock',
  REQUESTED_QUANTITY_UNAVAILABLE = 'Sorry, requested quantity is unavailable.',
  ORDER_QUANTITY_EXCEED = 'Order quantity limit exceeded.',
  DANGEROUS_ITEMS = 'Dangerous good',
  ITEM_AVAILABLE_CNC = 'Item only available through click and collect',
  UNAVAILABLE_FOR_DELIVERY = 'Unavailable for delivery',
  DISCONTINUED_PRODUCT = 'Discontinued product',
  NO_DELIVERY_OPTIONS_AVAILABLE = 'Sorry No delivery options available',
  SOLD_BY_METER_ITEM = 'Sold by meter item',
}
